import { render, staticRenderFns } from "./Shortcut.vue?vue&type=template&id=0379b80d&scoped=true&"
import script from "./Shortcut.vue?vue&type=script&lang=js&"
export * from "./Shortcut.vue?vue&type=script&lang=js&"
import style0 from "./Shortcut.vue?vue&type=style&index=0&id=0379b80d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379b80d",
  null
  
)

export default component.exports